import { getCurrentUiLocale } from 'libs/locales/ui';
import { txt } from 'libs/i18n';
export const CUSTOM_ASSIGNMENT_VALUE = 'custom';
export const assignmentKey = (name, scopeKind) => (`${scopeKind !== null && scopeKind !== void 0 ? scopeKind : 'global'}::${name}`);
export const getAssignmentOptions = (assignments) => {
    const options = assignments.map((assignment) => {
        var _a, _b;
        const labelText = (_b = (_a = assignment.localizations.find((localization) => localization.language === getCurrentUiLocale().code)) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : assignment.name;
        return {
            value: assignmentKey(assignment.name, assignment.scopeKind),
            name: assignment.name,
            scopeKind: assignment.scopeKind,
            label: labelText,
            result: assignment.result,
        };
    });
    return [...options, {
            value: CUSTOM_ASSIGNMENT_VALUE, name: 'Custom', label: txt('customPrompt'), result: 'Text',
        }];
};
export const getInitialAiAssignment = (options, sessionPromptKey) => {
    var _a;
    const savedAssignment = options.find((assignment) => assignment.value === sessionPromptKey);
    if (savedAssignment === undefined) {
        return (_a = options[0]) === null || _a === void 0 ? void 0 : _a.value;
    }
    return savedAssignment.value;
};
